import { graphql } from '@/gql';
import type { CreatePlanMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const createPlan = async (variables: CreatePlanMutationVariables) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreatePlan($input: PlanCreateInput!) {
        createPlan(input: $input) {
          id
          name
          kind
          amount
          isActive
          hasTrial
          trialPrice
          tier
          isDefault
          fragmentInto
          defragmentInto
          upgradeInto
          data
        }
      }
    `),
    variables,
  });

  if (!response.data?.createPlan) {
    throw new Error('Failed to create plan');
  }

  return response.data.createPlan;
};
